export default "__VITE_ASSET__DVPQVLbQ__"